import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/shared/Layout';
import { companyAPI } from '../../utils/api';

const SKILL_GROUPS = [
  // ── Siber Güvenlik ───────────────────────────────────────────────────────
  { label: '🔴 Sızma Testi & Exploit', skills: ['Metasploit', 'Burp Suite', 'SQLmap', 'Hydra', 'John the Ripper', 'Aircrack-ng', 'Nikto', 'ExploitDB', 'Cobalt Strike', 'Havoc C2', 'Sliver', 'Impacket', 'CrackMapExec', 'Responder'] },
  { label: '🌐 Ağ & Tarama Araçları', skills: ['Nmap', 'Wireshark', 'Nessus', 'OpenVAS', 'Snort', 'Zeek', 'tcpdump', 'Masscan', 'Zmap', 'Netcat', 'Ettercap'] },
  { label: '🕷️ Web Güvenliği', skills: ['OWASP Top 10', 'XSS', 'SQL Injection', 'SSRF', 'CSRF', 'XXE', 'IDOR', 'JWT Attacks', 'OAuth Attacks', 'GraphQL Security', 'API Security', 'SSTI'] },
  { label: '🦠 Zararlı Yazılım & Tersine Mühendislik', skills: ['Ghidra', 'IDA Pro', 'x64dbg', 'OllyDbg', 'Cuckoo Sandbox', 'YARA', 'Radare2', 'Binary Ninja', 'dnSpy', 'ANY.RUN'] },
  { label: '🛡️ Blue Team & SIEM', skills: ['Splunk', 'ELK Stack', 'QRadar', 'Wazuh', 'Suricata', 'Velociraptor', 'TheHive', 'MISP', 'Microsoft Sentinel', 'Elastic SIEM', 'Graylog'] },
  { label: '🔍 DFIR & OSINT', skills: ['Autopsy', 'FTK', 'Volatility', 'KAPE', 'NetworkMiner', 'Maltego', 'Shodan', 'Censys', 'theHarvester', 'Recon-ng'] },
  { label: '☁️ Bulut & Konteyner Güvenliği', skills: ['AWS Security', 'Azure Security', 'GCP Security', 'Docker Security', 'Kubernetes Security', 'Terraform', 'Prowler', 'Trivy', 'Falco'] },
  { label: '⚙️ GRC & Uyum', skills: ['ISO 27001', 'NIST CSF', 'KVKK', 'GDPR', 'PCI-DSS', 'SOC 2', 'NIS2', 'Risk Analizi', 'Denetim'] },
  // ── Yazılım Geliştirme ───────────────────────────────────────────────────
  { label: '🖥️ Programlama Dilleri', skills: ['Python', 'JavaScript', 'TypeScript', 'Java', 'C', 'C++', 'C#', 'Go', 'Rust', 'Kotlin', 'Swift', 'PHP', 'Bash', 'PowerShell', 'Assembly', 'R'] },
  { label: '🔧 Backend Geliştirme', skills: ['Node.js', 'Express.js', 'Django', 'FastAPI', 'Flask', 'Spring Boot', '.NET Core', 'NestJS', 'GraphQL', 'REST API', 'Microservices', 'gRPC'] },
  { label: '🎨 Frontend Geliştirme', skills: ['React', 'Vue.js', 'Angular', 'Next.js', 'TypeScript', 'Tailwind CSS', 'HTML5', 'CSS3', 'Redux', 'Webpack', 'Vite'] },
  { label: '📱 Mobil Geliştirme', skills: ['React Native', 'Flutter', 'Swift', 'Kotlin', 'Jetpack Compose', 'Expo', 'Firebase'] },
  { label: '🗄️ Veritabanı', skills: ['PostgreSQL', 'MySQL', 'MongoDB', 'Redis', 'Elasticsearch', 'SQLite', 'Microsoft SQL Server', 'Cassandra', 'DynamoDB'] },
  { label: '🚀 DevOps & CI/CD', skills: ['Docker', 'Kubernetes', 'GitHub Actions', 'GitLab CI', 'Jenkins', 'Ansible', 'Terraform', 'Helm', 'Prometheus', 'Grafana', 'Linux', 'Git'] },
  { label: '🤖 Veri Bilimi & YZ', skills: ['Pandas', 'NumPy', 'Scikit-learn', 'TensorFlow', 'PyTorch', 'Keras', 'Hugging Face', 'LangChain', 'Jupyter', 'Apache Spark'] },
  // ── İş Geliştirme ────────────────────────────────────────────────────────
  { label: '📊 Analitik & İş Araçları', skills: ['Google Analytics', 'Power BI', 'Tableau', 'Excel / VBA', 'Looker Studio', 'SQL', 'Metabase', 'Notion', 'Jira', 'Confluence'] },
  { label: '📣 Pazarlama & Büyüme', skills: ['SEO', 'SEM / Google Ads', 'Meta Ads', 'HubSpot', 'Mailchimp', 'Canva', 'İçerik Pazarlama', 'Growth Hacking', 'A/B Testi'] },
  { label: '💼 Satış & Ürün', skills: ['CRM', 'Salesforce', 'Figma', 'Product Roadmap', 'OKR', 'Kullanıcı Araştırması', 'Pazar Analizi', 'LinkedIn Sales Navigator'] },
];

const FOCUS_AREAS = [
  // Siber Güvenlik
  'Penetration Testing', 'Web Uygulama Güvenliği', 'Ağ Güvenliği',
  'Zararlı Yazılım Analizi', 'Dijital Adli Bilişim (DFIR)',
  'Güvenlik Operasyonları (SOC)', 'Bulut Güvenliği',
  'Kriptografi', 'Tersine Mühendislik', 'Bug Bounty',
  'Red Team', 'Blue Team', 'Threat Intelligence',
  'GRC & Uyum', 'Uygulama Güvenliği (AppSec)', 'OT/ICS Güvenliği',
  // Yazılım
  'Backend Geliştirme', 'Frontend Geliştirme', 'Mobil Geliştirme',
  'DevOps / DevSecOps', 'Veri Bilimi', 'Makine Öğrenmesi',
  'API Tasarımı', 'Mikroservis Mimarisi', 'Veritabanı Yönetimi',
  // İş Geliştirme
  'İş Geliştirme', 'Ürün Yönetimi', 'Dijital Pazarlama',
  'Teknik Satış', 'Müşteri Başarısı', 'Büyüme & Analitik',
];

const PREFERRED_CERTS = [
  // Siber Güvenlik
  'CompTIA Security+', 'CompTIA CySA+', 'CompTIA PenTest+', 'CompTIA CASP+',
  'CEH', 'CPENT', 'CHFI',
  'OSCP', 'OSEP', 'OSWE', 'OSED',
  'eJPT', 'eCPPT', 'eWPT', 'eWPTX',
  'CISSP', 'CCSP', 'CISM', 'CISA', 'CRISC',
  'CCNA Security', 'Cisco CyberOps Associate',
  'GPEN', 'GCIH', 'GCFE', 'GREM',
  'TCM Security PNPT',
  'ISO 27001 Lead Implementer', 'ISO 27001 Lead Auditor',
  'Hack The Box Pro Hacker', 'TryHackMe Top 1%',
  // Bulut & Altyapı
  'AWS Cloud Practitioner', 'AWS Solutions Architect Associate', 'AWS Security Specialty',
  'Azure Fundamentals (AZ-900)', 'Azure Security Engineer', 'Azure Administrator (AZ-104)',
  'Google Cloud Associate',
  'CKA (Kubernetes Administrator)', 'CKAD', 'CKS (Kubernetes Security)',
  'Docker Certified Associate', 'HashiCorp Terraform Associate',
  // Yazılım & Veri
  'Google Data Analytics', 'IBM Data Science Professional',
  'TensorFlow Developer', 'Tableau Desktop Specialist', 'Microsoft Power BI Data Analyst',
  // İş & Proje
  'Professional Scrum Master (PSM I)', 'PMI PMP', 'ITIL 4 Foundation',
  'Google Analytics Individual', 'HubSpot Inbound Marketing',
];

const TEMPLATES = [
  // ── Siber Güvenlik ──────────────────────────────
  {
    category: '🔐 Siber Güvenlik',
    label: 'Sızma Testi Stajyeri',
    form: {
      title: 'Sızma Testi Stajyeri',
      description: 'Ağ ve web uygulama sızma testleri gerçekleştirecek, güvenlik açıkları raporlayacak stajyer arıyoruz.',
      preferred_skills: ['Metasploit', 'Burp Suite', 'Nmap', 'OWASP Top 10', 'Python'],
      focus_areas: ['Penetration Testing', 'Web Uygulama Güvenliği'],
      preferred_certs: ['eJPT', 'OSCP'],
      internship_type: 'onsite', duration_weeks: 8, quota: 2, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği', 'Siber Güvenlik'],
      required_min_gpa: '', required_min_grade: '', required_city: '', start_date: '',
    },
  },
  {
    category: '🔐 Siber Güvenlik',
    label: 'SOC Analisti Stajyeri',
    form: {
      title: 'SOC Analisti Stajyeri',
      description: 'Güvenlik operasyonları merkezimizde tehdit izleme, log analizi ve olay müdahalesi konularında staj imkânı.',
      preferred_skills: ['Splunk', 'ELK Stack', 'Wireshark', 'Snort', 'Suricata'],
      focus_areas: ['Güvenlik Operasyonları (SOC)', 'Blue Team', 'Threat Intelligence'],
      preferred_certs: ['CompTIA Security+', 'CompTIA CySA+'],
      internship_type: 'hybrid', duration_weeks: 10, quota: 1, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği', 'Bilişim Sistemleri'],
      required_min_gpa: '', required_min_grade: '', required_city: '', start_date: '',
    },
  },
  {
    category: '🔐 Siber Güvenlik',
    label: 'Zararlı Yazılım Analisti',
    form: {
      title: 'Zararlı Yazılım Analizi Stajyeri',
      description: 'Zararlı yazılım analizi ve tersine mühendislik projelerinde görev alacak stajyer arıyoruz.',
      preferred_skills: ['Ghidra', 'x64dbg', 'Cuckoo Sandbox', 'YARA', 'Python', 'Assembly'],
      focus_areas: ['Zararlı Yazılım Analizi', 'Tersine Mühendislik', 'Red Team'],
      preferred_certs: ['CEH', 'eJPT'],
      internship_type: 'onsite', duration_weeks: 12, quota: 1, is_paid: false,
      required_departments: ['Bilgisayar Mühendisliği'],
      required_min_gpa: '2.50', required_min_grade: '3', required_city: '', start_date: '',
    },
  },
  {
    category: '🔐 Siber Güvenlik',
    label: 'Bulut Güvenliği Stajyeri',
    form: {
      title: 'Bulut Güvenliği Stajyeri',
      description: 'AWS/Azure altyapı güvenliği, IAM yapılandırması ve bulut sızma testi projelerinde çalışma fırsatı.',
      preferred_skills: ['AWS Security', 'Azure Security', 'Docker Security', 'Terraform', 'Python'],
      focus_areas: ['Bulut Güvenliği', 'Penetration Testing'],
      preferred_certs: ['CompTIA Security+', 'CCNA Security'],
      internship_type: 'remote', duration_weeks: 8, quota: 2, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği', 'Siber Güvenlik'],
      required_min_gpa: '', required_min_grade: '', required_city: '', start_date: '',
    },
  },
  {
    category: '🔐 Siber Güvenlik',
    label: 'Threat Intelligence Stajyeri',
    form: {
      title: 'Threat Intelligence Stajyeri',
      description: 'Siber tehdit istihbaratı toplama, APT grupları takibi ve IOC analizi konularında çalışacak stajyer arıyoruz.',
      preferred_skills: ['MISP', 'OpenCTI', 'Maltego', 'Python', 'OSINT', 'STIX/TAXII'],
      focus_areas: ['Threat Intelligence', 'Blue Team', 'Güvenlik Operasyonları (SOC)'],
      preferred_certs: ['CompTIA Security+', 'CEH'],
      internship_type: 'hybrid', duration_weeks: 10, quota: 1, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği', 'Uluslararası İlişkiler', 'Siber Güvenlik'],
      required_min_gpa: '', required_min_grade: '', required_city: '', start_date: '',
    },
  },
  {
    category: '🔐 Siber Güvenlik',
    label: 'GRC & Uyum Stajyeri',
    form: {
      title: 'GRC & Siber Uyum Stajyeri',
      description: 'ISO 27001, KVKK ve NIS2 kapsamında risk değerlendirmesi, politika hazırlama ve denetim süreçlerinde görev alacak stajyer arıyoruz.',
      preferred_skills: ['ISO 27001', 'KVKK', 'Risk Analizi', 'Denetim', 'MS Office'],
      focus_areas: ['GRC & Uyum'],
      preferred_certs: ['CISM', 'CISSP', 'CompTIA Security+'],
      internship_type: 'hybrid', duration_weeks: 8, quota: 2, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği', 'Hukuk', 'İşletme', 'Endüstri Mühendisliği'],
      required_min_gpa: '', required_min_grade: '', required_city: '', start_date: '',
    },
  },
  {
    category: '🔐 Siber Güvenlik',
    label: 'Adli Bilişim (DFIR) Stajyeri',
    form: {
      title: 'Dijital Adli Bilişim Stajyeri',
      description: 'Siber olay müdahalesi, disk/bellek adli analizi ve log inceleme konularında deneyim kazanacak stajyer arıyoruz.',
      preferred_skills: ['Autopsy', 'Volatility', 'FTK', 'Wireshark', 'Linux', 'Python'],
      focus_areas: ['Dijital Adli Bilişim (DFIR)', 'Blue Team', 'Güvenlik Operasyonları (SOC)'],
      preferred_certs: ['CompTIA Security+', 'GCFE', 'eJPT'],
      internship_type: 'onsite', duration_weeks: 10, quota: 1, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği'],
      required_min_gpa: '2.50', required_min_grade: '', required_city: '', start_date: '',
    },
  },
  // ── Yazılım ─────────────────────────────────────
  {
    category: '💻 Yazılım',
    label: 'Backend Geliştirici Stajyeri',
    form: {
      title: 'Backend Yazılım Geliştirici Stajyeri',
      description: 'REST API geliştirme, veritabanı tasarımı ve sunucu tarafı uygulama geliştirme projelerinde çalışacak stajyer arıyoruz.',
      preferred_skills: ['Node.js', 'Python', 'PostgreSQL', 'REST API', 'Docker', 'Git'],
      focus_areas: ['Backend Geliştirme', 'API Tasarımı', 'Veritabanı Yönetimi'],
      preferred_certs: [],
      internship_type: 'hybrid', duration_weeks: 8, quota: 2, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği', 'Yazılım Mühendisliği'],
      required_min_gpa: '', required_min_grade: '2', required_city: '', start_date: '',
    },
  },
  {
    category: '💻 Yazılım',
    label: 'Frontend Geliştirici Stajyeri',
    form: {
      title: 'Frontend Geliştirici Stajyeri',
      description: 'Modern web arayüzleri geliştirmek, kullanıcı deneyimi iyileştirmeleri yapmak üzere stajyer arıyoruz.',
      preferred_skills: ['React', 'JavaScript', 'TypeScript', 'HTML/CSS', 'Tailwind CSS', 'Git'],
      focus_areas: ['Frontend Geliştirme'],
      preferred_certs: [],
      internship_type: 'remote', duration_weeks: 8, quota: 2, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği', 'Yazılım Mühendisliği', 'Tasarım'],
      required_min_gpa: '', required_min_grade: '', required_city: '', start_date: '',
    },
  },
  {
    category: '💻 Yazılım',
    label: 'Mobil Uygulama Stajyeri',
    form: {
      title: 'Mobil Uygulama Geliştirici Stajyeri',
      description: 'iOS ve/veya Android platformu için mobil uygulama geliştirme süreçlerinde yer alacak stajyer arıyoruz.',
      preferred_skills: ['React Native', 'Flutter', 'Swift', 'Kotlin', 'Firebase', 'Git'],
      focus_areas: ['Mobil Geliştirme'],
      preferred_certs: [],
      internship_type: 'hybrid', duration_weeks: 8, quota: 1, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği', 'Yazılım Mühendisliği'],
      required_min_gpa: '', required_min_grade: '2', required_city: '', start_date: '',
    },
  },
  {
    category: '💻 Yazılım',
    label: 'DevOps / DevSecOps Stajyeri',
    form: {
      title: 'DevOps & DevSecOps Stajyeri',
      description: 'CI/CD pipeline kurulumu, konteyner orkestrasyon ve altyapı otomasyonu projelerinde görev alacak stajyer arıyoruz.',
      preferred_skills: ['Docker', 'Kubernetes', 'GitHub Actions', 'Terraform', 'Linux', 'Python'],
      focus_areas: ['DevOps / DevSecOps', 'Bulut Güvenliği'],
      preferred_certs: ['CompTIA Security+', 'AWS Cloud Practitioner'],
      internship_type: 'remote', duration_weeks: 10, quota: 1, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği', 'Yazılım Mühendisliği'],
      required_min_gpa: '', required_min_grade: '2', required_city: '', start_date: '',
    },
  },
  {
    category: '💻 Yazılım',
    label: 'Veri Bilimi & YZ Stajyeri',
    form: {
      title: 'Veri Bilimi & Yapay Zeka Stajyeri',
      description: 'Makine öğrenmesi modelleri geliştirme, veri analizi ve yapay zeka projelerinde çalışacak stajyer arıyoruz.',
      preferred_skills: ['Python', 'Pandas', 'Scikit-learn', 'TensorFlow', 'SQL', 'Jupyter'],
      focus_areas: ['Veri Bilimi', 'Makine Öğrenmesi'],
      preferred_certs: [],
      internship_type: 'hybrid', duration_weeks: 12, quota: 2, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği', 'Matematik', 'İstatistik', 'Endüstri Mühendisliği'],
      required_min_gpa: '2.75', required_min_grade: '2', required_city: '', start_date: '',
    },
  },
  // ── İş Geliştirme ────────────────────────────────
  {
    category: '📈 İş Geliştirme',
    label: 'İş Geliştirme Stajyeri',
    form: {
      title: 'İş Geliştirme Stajyeri',
      description: 'Yeni iş fırsatlarını araştırma, potansiyel müşteri analizi ve stratejik ortaklık süreçlerinde görev alacak stajyer arıyoruz.',
      preferred_skills: ['CRM', 'LinkedIn Sales Navigator', 'Excel', 'Sunum Hazırlama', 'Pazar Araştırması'],
      focus_areas: ['İş Geliştirme'],
      preferred_certs: [],
      internship_type: 'hybrid', duration_weeks: 8, quota: 2, is_paid: true,
      required_departments: ['İşletme', 'Uluslararası İlişkiler', 'Ekonomi', 'Endüstri Mühendisliği'],
      required_min_gpa: '', required_min_grade: '', required_city: '', start_date: '',
    },
  },
  {
    category: '📈 İş Geliştirme',
    label: 'Ürün Yönetimi (PM) Stajyeri',
    form: {
      title: 'Ürün Yönetimi Stajyeri',
      description: 'Ürün yol haritası oluşturma, kullanıcı araştırması ve özellik önceliklendirme süreçlerinde yer alacak stajyer arıyoruz.',
      preferred_skills: ['Figma', 'Jira', 'SQL', 'A/B Testi', 'Kullanıcı Araştırması', 'Notion'],
      focus_areas: ['Ürün Yönetimi', 'Büyüme & Analitik'],
      preferred_certs: [],
      internship_type: 'hybrid', duration_weeks: 10, quota: 1, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği', 'İşletme', 'Endüstri Mühendisliği'],
      required_min_gpa: '', required_min_grade: '2', required_city: '', start_date: '',
    },
  },
  {
    category: '📈 İş Geliştirme',
    label: 'Dijital Pazarlama Stajyeri',
    form: {
      title: 'Dijital Pazarlama & Büyüme Stajyeri',
      description: 'SEO/SEM, sosyal medya yönetimi, içerik üretimi ve dijital kampanya optimizasyonu alanlarında çalışacak stajyer arıyoruz.',
      preferred_skills: ['Google Analytics', 'SEO', 'Meta Ads', 'Canva', 'İçerik Yazarlığı', 'HubSpot'],
      focus_areas: ['Dijital Pazarlama', 'Büyüme & Analitik'],
      preferred_certs: [],
      internship_type: 'remote', duration_weeks: 8, quota: 2, is_paid: false,
      required_departments: ['İşletme', 'İletişim', 'Halkla İlişkiler', 'Ekonomi'],
      required_min_gpa: '', required_min_grade: '', required_city: '', start_date: '',
    },
  },
  {
    category: '📈 İş Geliştirme',
    label: 'Teknik Satış Stajyeri',
    form: {
      title: 'Teknik Satış & Çözüm Ortaklığı Stajyeri',
      description: 'Siber güvenlik çözümlerinin teknik satış süreçlerinde, müşteri demo ve POC hazırlıklarında görev alacak stajyer arıyoruz.',
      preferred_skills: ['Sunum Hazırlama', 'CRM', 'Siber Güvenlik Temelleri', 'Excel', 'İletişim'],
      focus_areas: ['Teknik Satış', 'Müşteri Başarısı'],
      preferred_certs: ['CompTIA Security+'],
      internship_type: 'hybrid', duration_weeks: 8, quota: 2, is_paid: true,
      required_departments: ['Bilgisayar Mühendisliği', 'İşletme', 'Uluslararası İlişkiler'],
      required_min_gpa: '', required_min_grade: '', required_city: '', start_date: '',
    },
  },
];

const emptyForm = {
  title: '',
  description: '',
  required_departments: [],
  required_min_grade: '',
  required_min_gpa: '',
  required_city: '',
  preferred_skills: [],
  preferred_certs: [],
  focus_areas: [],
  internship_type: 'onsite',
  quota: 1,
  duration_weeks: 8,
  is_paid: false,
  start_date: '',
};

const CompanyPositions = () => {
  const [positions, setPositions] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [deleting, setDeleting] = useState(null);
  const [editingId, setEditingId] = useState(null);

  const handleEdit = (p) => {
    // preferred_skills'i skill / cert / focus_area olarak ayrıştır gerekmez —
    // tamamını preferred_skills'e koy, form zaten birleştirecek
    setForm({
      title: p.title || '',
      description: p.description || '',
      required_departments: p.required_departments || [],
      required_min_grade: p.required_min_grade || '',
      required_min_gpa: p.required_min_gpa || '',
      required_city: p.required_city || '',
      preferred_skills: p.preferred_skills || [],
      preferred_certs: [],
      focus_areas: [],
      internship_type: p.internship_type || 'onsite',
      quota: p.quota || 1,
      duration_weeks: p.duration_weeks || 8,
      is_paid: p.is_paid || false,
      start_date: p.start_date ? p.start_date.slice(0, 10) : '',
    });
    setEditingId(p.id);
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (id, force = false) => {
    if (!force && !window.confirm('Bu ilanı silmek istediğinizden emin misiniz?')) return;
    setDeleting(id);
    try {
      await companyAPI.deletePosition(id, force);
      setPositions(ps => ps.filter(p => p.id !== id));
    } catch (err) {
      const data = err?.response?.data;
      if (data?.code === 'has_applications') {
        setDeleting(null);
        const confirmed = window.confirm(
          `⚠️ Bu ilana bağlı ${data.count} başvuru bulunmaktadır.\n\nİlanı ve tüm başvuruları kalıcı olarak silmek istiyor musunuz?`
        );
        if (confirmed) handleDelete(id, true);
        return;
      }
      alert('İlan silinemedi, tekrar deneyin.');
    }
    setDeleting(null);
  };
  const [showTemplates, setShowTemplates] = useState(false);

  useEffect(() => {
    companyAPI.getPositions().then(r => setPositions(r.data)).catch(() => {});
  }, []);

  const toggleArr = (field, value) => setForm(f => {
    const cur = f[field] || [];
    return { ...f, [field]: cur.includes(value) ? cur.filter(x => x !== value) : [...cur, value] };
  });

  const handleSubmit = async () => {
    setSaving(true); setError('');
    try {
      // focus_areas ve preferred_certs'i preferred_skills içine dahil et (backend tek alan bekliyor)
      const allSkills = [...new Set([...form.preferred_skills, ...form.focus_areas, ...form.preferred_certs])];
      const payload = {
        ...form,
        required_departments: form.required_departments.filter(Boolean),
        preferred_skills: allSkills,
        required_min_grade: form.required_min_grade || null,
        required_min_gpa: form.required_min_gpa || null,
        required_city: form.required_city || null,
        start_date: form.start_date || null,
      };
      if (editingId) {
        await companyAPI.updatePosition(editingId, payload);
      } else {
        await companyAPI.createPosition(payload);
      }
      const r = await companyAPI.getPositions();
      setPositions(r.data);
      setShowForm(false);
      setForm(emptyForm);
      setEditingId(null);
    } catch (e) {
      setError(e.response?.data?.error || 'İlan oluşturulamadı');
    } finally {
      setSaving(false);
    }
  };

  const inp = { width: '100%', padding: '9px 13px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' };
  const lbl = { display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 };

  const Chip = ({ label, selected, onClick, color = '#2563eb', bg = '#eff6ff' }) => (
    <button type="button" onClick={onClick} style={{
      padding: '5px 13px', borderRadius: 20, cursor: 'pointer', fontSize: 13,
      border: `1.5px solid ${selected ? color : '#e5e7eb'}`,
      background: selected ? bg : '#fff',
      color: selected ? color : '#374151',
      fontWeight: selected ? 500 : 400,
    }}>{label}</button>
  );

  return (
    <Layout>
      <div style={{ maxWidth: 820 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h1 style={{ fontSize: 22, fontWeight: 700, color: '#111827' }}>İlanlarım</h1>
          <button onClick={() => { setShowForm(s => !s); setEditingId(null); setForm(emptyForm); }} style={{
            padding: '10px 20px', background: showForm ? '#f3f4f6' : '#2563eb',
            color: showForm ? '#374151' : '#fff', border: showForm ? '1px solid #d1d5db' : 'none',
            borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer'
          }}>
            {showForm ? 'İptal' : '+ Yeni İlan'}
          </button>
        </div>

        {/* Yeni ilan formu */}
        {showForm && (
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: 28, marginBottom: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
              <h2 style={{ fontSize: 18, fontWeight: 700, color: '#111827' }}>Yeni Staj İlanı</h2>
              <div style={{ position: 'relative' }}>
                <button type="button" onClick={() => setShowTemplates(s => !s)} style={{
                  padding: '8px 16px', background: '#f5f3ff', color: '#7c3aed',
                  border: '1px solid #ddd6fe', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500,
                }}>
                  ⚡ Şablon Kullan
                </button>
                {showTemplates && (
                  <div style={{
                    position: 'absolute', right: 0, top: '110%', zIndex: 20,
                    background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)', minWidth: 280, maxHeight: 420, overflowY: 'auto', padding: 8,
                  }}>
                    {(() => {
                      const cats = [...new Set(TEMPLATES.map(t => t.category))];
                      return cats.map(cat => (
                        <div key={cat}>
                          <div style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', padding: '6px 14px 2px', letterSpacing: '0.05em' }}>{cat}</div>
                          {TEMPLATES.filter(t => t.category === cat).map(t => (
                            <button key={t.label} type="button" onClick={() => { setForm({ ...emptyForm, ...t.form }); setShowTemplates(false); }} style={{
                              display: 'block', width: '100%', textAlign: 'left',
                              padding: '8px 14px 8px 20px', background: 'none', border: 'none',
                              borderRadius: 6, fontSize: 13, color: '#111827', cursor: 'pointer',
                            }}
                              onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
                              onMouseLeave={e => e.currentTarget.style.background = 'none'}
                            >
                              {t.label}
                            </button>
                          ))}
                        </div>
                      ));
                    })()}
                  </div>
                )}
              </div>
            </div>
            {error && <div style={{ background: '#fef2f2', color: '#dc2626', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 13 }}>{error}</div>}

            {/* Temel Bilgiler */}
            <div style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#111827', marginBottom: 16, paddingBottom: 8, borderBottom: '2px solid #e5e7eb' }}>
                Temel Bilgiler
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={lbl}>Pozisyon Adı *</label>
                  <input style={inp} value={form.title}
                    onChange={e => setForm(f => ({ ...f, title: e.target.value }))}
                    placeholder="örn: Sızma Testi Stajyeri, SOC Analisti, Güvenlik Araştırmacısı, DFIR Stajyeri..." />
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={lbl}>Pozisyon Açıklaması</label>
                  <textarea rows={4} style={{ ...inp, resize: 'vertical' }}
                    value={form.description}
                    onChange={e => setForm(f => ({ ...f, description: e.target.value }))}
                    placeholder="Stajyerin katılacağı projeler, sorumluluklar, öğreneceği teknolojiler..." />
                </div>
                <div>
                  <label style={lbl}>Zorunlu Bölüm</label>
                  <input style={inp}
                    placeholder="Bilgisayar Müh., Siber Güvenlik, Bilişim Sistemleri..."
                    value={form.required_departments.join(', ')}
                    onChange={e => setForm(f => ({ ...f, required_departments: e.target.value.split(',').map(s => s.trim()) }))} />
                </div>
                <div>
                  <label style={lbl}>Zorunlu Şehir (boş = uzaktan)</label>
                  <input style={inp} value={form.required_city}
                    onChange={e => setForm(f => ({ ...f, required_city: e.target.value }))} />
                </div>
                <div>
                  <label style={lbl}>Min. Sınıf</label>
                  <select style={inp} value={form.required_min_grade}
                    onChange={e => setForm(f => ({ ...f, required_min_grade: e.target.value }))}>
                    <option value="">Fark etmez</option>
                    <option value="2">2. Sınıf ve üzeri</option>
                    <option value="3">3. Sınıf ve üzeri</option>
                    <option value="4">4. Sınıf (mezun adayı)</option>
                  </select>
                </div>
                <div>
                  <label style={lbl}>Min. GPA</label>
                  <input type="number" step="0.01" min={0} max={4} style={inp}
                    value={form.required_min_gpa}
                    placeholder="örn: 2.50"
                    onChange={e => setForm(f => ({ ...f, required_min_gpa: e.target.value }))} />
                </div>
                <div>
                  <label style={lbl}>Çalışma Şekli</label>
                  <select style={inp} value={form.internship_type}
                    onChange={e => setForm(f => ({ ...f, internship_type: e.target.value }))}>
                    <option value="onsite">Ofisten</option>
                    <option value="remote">Uzaktan</option>
                    <option value="hybrid">Hibrit</option>
                  </select>
                </div>
                <div>
                  <label style={lbl}>Süre (hafta)</label>
                  <input type="number" min={1} style={inp} value={form.duration_weeks}
                    onChange={e => setForm(f => ({ ...f, duration_weeks: e.target.value }))} />
                </div>
                <div>
                  <label style={lbl}>Başlangıç Tarihi</label>
                  <input type="date" style={inp} value={form.start_date}
                    onChange={e => setForm(f => ({ ...f, start_date: e.target.value }))} />
                </div>
                <div>
                  <label style={lbl}>Kontenjan</label>
                  <input type="number" min={1} style={inp} value={form.quota}
                    onChange={e => setForm(f => ({ ...f, quota: e.target.value }))} />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, paddingTop: 20 }}>
                  <input type="checkbox" id="is_paid" checked={form.is_paid}
                    onChange={e => setForm(f => ({ ...f, is_paid: e.target.checked }))}
                    style={{ width: 16, height: 16, cursor: 'pointer' }} />
                  <label htmlFor="is_paid" style={{ fontSize: 14, color: '#374151', cursor: 'pointer' }}>Ücretli staj</label>
                </div>
              </div>
            </div>

            {/* Odak Alanları */}
            <div style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#111827', marginBottom: 8, paddingBottom: 8, borderBottom: '2px solid #e5e7eb' }}>
                Staj Odak Alanı
              </div>
              <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 12 }}>Bu stajın hangi siber güvenlik alanına odaklandığını seçin</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {FOCUS_AREAS.map(area => (
                  <Chip key={area} label={area}
                    selected={form.focus_areas.includes(area)}
                    onClick={() => toggleArr('focus_areas', area)}
                    color="#7c3aed" bg="#f5f3ff"
                  />
                ))}
              </div>
            </div>

            {/* Teknik Araç & Beceri Talepleri */}
            <div style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#111827', marginBottom: 8, paddingBottom: 8, borderBottom: '2px solid #e5e7eb' }}>
                Tercih Edilen Teknik Araçlar & Beceriler
              </div>
              <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 14 }}>
                AI eşleştirme algoritması bu seçimleri öğrenci profilleriyle karşılaştırır
              </p>
              {SKILL_GROUPS.map(group => (
                <div key={group.label} style={{ marginBottom: 18 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8, paddingBottom: 6, borderBottom: '1px solid #f3f4f6' }}>
                    {group.label}
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                    {group.skills.map(skill => (
                      <Chip key={skill} label={skill}
                        selected={form.preferred_skills.includes(skill)}
                        onClick={() => toggleArr('preferred_skills', skill)}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Tercih Edilen Sertifikalar */}
            <div style={{ marginBottom: 28 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: '#111827', marginBottom: 8, paddingBottom: 8, borderBottom: '2px solid #e5e7eb' }}>
                Tercih Edilen Sertifikalar (zorunlu değil)
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {PREFERRED_CERTS.map(cert => (
                  <Chip key={cert} label={cert}
                    selected={form.preferred_certs.includes(cert)}
                    onClick={() => toggleArr('preferred_certs', cert)}
                    color="#059669" bg="#ecfdf5"
                  />
                ))}
              </div>
            </div>

            <div style={{ display: 'flex', gap: 12 }}>
              <button onClick={handleSubmit} disabled={saving || !form.title} style={{
                padding: '11px 28px', background: saving || !form.title ? '#93c5fd' : '#2563eb',
                color: '#fff', border: 'none', borderRadius: 8,
                fontSize: 14, fontWeight: 600, cursor: saving || !form.title ? 'not-allowed' : 'pointer'
              }}>
                {saving ? 'Kaydediliyor...' : editingId ? 'Değişiklikleri Kaydet' : 'İlanı Oluştur'}
              </button>
              <button type="button" onClick={() => { setShowForm(false); setForm(emptyForm); setError(''); }} style={{
                padding: '11px 20px', background: '#f3f4f6', color: '#374151',
                border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, cursor: 'pointer'
              }}>
                İptal
              </button>
            </div>
          </div>
        )}

        {/* İlan Listesi */}
        {positions.length === 0 && !showForm ? (
          <div style={{ textAlign: 'center', padding: '60px 0', color: '#6b7280' }}>
            <p style={{ fontWeight: 500 }}>Henüz ilan yok</p>
            <p style={{ fontSize: 13 }}>İlk siber güvenlik staj ilanınızı oluşturun.</p>
          </div>
        ) : (
          positions.map(p => {
            const skills = p.preferred_skills || [];
            return (
              <div key={p.id} style={{
                background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12,
                padding: 20, marginBottom: 12
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 15, color: '#111827' }}>{p.title}</div>
                    <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>
                      {p.matched_count || 0} eşleşme · {p.invited_count || 0} davet
                      {p.internship_type && ` · ${p.internship_type === 'remote' ? 'Uzaktan' : p.internship_type === 'hybrid' ? 'Hibrit' : 'Ofisten'}`}
                      {p.duration_weeks && ` · ${p.duration_weeks} hafta`}
                      {p.is_paid && ' · Ücretli'}
                    </div>
                    {skills.length > 0 && (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 10 }}>
                        {skills.slice(0, 6).map(s => (
                          <span key={s} style={{ fontSize: 11, background: '#eff6ff', color: '#1d4ed8', padding: '2px 8px', borderRadius: 20 }}>{s}</span>
                        ))}
                        {skills.length > 6 && <span style={{ fontSize: 11, color: '#9ca3af' }}>+{skills.length - 6}</span>}
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginLeft: 16, alignItems: 'center' }}>
                    <Link to={`/company/candidates/${p.id}`} style={{
                      padding: '8px 16px', background: '#eff6ff', color: '#1d4ed8',
                      borderRadius: 8, textDecoration: 'none', fontSize: 13,
                      fontWeight: 500, whiteSpace: 'nowrap'
                    }}>
                      Adayları Gör →
                    </Link>
                    <button onClick={() => handleEdit(p)}
                      style={{
                        padding: '8px 14px', background: '#f0fdf4', color: '#16a34a',
                        border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer', whiteSpace: 'nowrap'
                      }}>
                      ✏️ Düzenle
                    </button>
                    <button onClick={() => handleDelete(p.id)} disabled={deleting === p.id}
                      style={{
                        padding: '8px 14px', background: deleting === p.id ? '#fca5a5' : '#fee2e2',
                        color: '#dc2626', border: 'none', borderRadius: 8,
                        fontSize: 13, fontWeight: 500, cursor: 'pointer', whiteSpace: 'nowrap'
                      }}>
                      {deleting === p.id ? '⏳' : '🗑️ Sil'}
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </Layout>
  );
};

export default CompanyPositions;
